import React, { useEffect, useState } from "react";
import less from "./loader.module.scss";
import { Fetch } from "../../utils/fetch";

function PaymentPage() {
  const [status, setStatus] = useState("loading");
  // "loading" | "success" | "error"

  const fetchStatus = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const orderId = params.get("order_id"); // e.g., "EW-1757071712901"
      const url = `/user/transactionStatus?orderId=${orderId}`;
      const options = { method: "GET" };
      const response = await Fetch(url, options);
      if (response === "SUCCESS") {
        setStatus("success");
        setTimeout(() => {
          window.location.href = "/wallet";
        }, 2000);
      } else {
        setStatus("error");
        setTimeout(() => {
          window.location.href = "/wallet";
        }, 2000);
      }
    } catch (error) {
      setStatus("error");
    }
  };

  useEffect(() => {
    const timer = setTimeout(fetchStatus, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {status === "loading" && (
        <div>
          <div className={less.loader}></div>
          <p>Processing your payment...</p>
        </div>
      )}

      {status === "success" && (
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
            alt="Success"
            width={150}
          />
          <h2>Payment Successful!</h2>
        </div>
      )}

      {status === "error" && (
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/463/463612.png"
            alt="Error"
            width={150}
          />
          <h2>Payment Failed!</h2>
        </div>
      )}
    </div>
  );
}

export default PaymentPage;
